import { renderMobile } from "app/header/MobileMenu";
import { titleFromPath } from "app/header/parts/HeaderTitle";
import { isEn } from "app/i18n/i18n";
import { Modal, Navbar } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { menuSlice } from "redux/slices/menuSlice";
import menuItemsEn from "../config/menuItems_en.json";
import menuItemsJa from "../config/menuItems_ja.json";

export const MobileMenu = () => {
  const menuItems = isEn() ? menuItemsEn : menuItemsJa;
  const showMenu = useSelector((state) => state.menu.showMenu);
  const setShowMenu = (bool) => dispatch(menuSlice.actions.setShowMenu(bool));
  const dispatch = useDispatch();

  return (
    <Modal show={showMenu} onHide={() => setShowMenu(false)} className="mobile-menu">
      {menuItems.map(linksToLabels).map(renderMobile)};
    </Modal>
  );
};

export const MobileMenuButton = () => {
  const dispatch = useDispatch();
  return <Navbar.Toggle className="ml-auto border-0" onClick={() => dispatch(menuSlice.actions.setShowMenu(true))} />;
};

const linksToLabels = (item) => {
  item.label = item.label || titleFromPath(item.link || "");
  return item;
};
